import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  list: [],
  item: null,
};

const zpCDovod = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_ZP_C_DOVOD_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_ZP_C_DOVOD_SUCCESS:
      return { ...state, isLoading: false, list: action.res.Data };

    case actionTypes.GET_ZP_C_DOVOD_FAILURE:
      return _initState;

    case actionTypes.CHANGE_DOVOD:
      return { ...state, item: action.data };

    default:
      return state;
  }
};

export default zpCDovod;
